module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/guide-improving-small-2caa04ba680c6c8cb694a6ffcfc4614a.svg";